import { useEffect, useState } from "react";
import MyResponsivePie from "./Charts/PieChart";
import "./styles.css";
import { fetchCertByRef, fetchResults } from "../../../../api/Evaluation";
import EventRateChart from "./Charts/EventRateChart";
import SatisfactionRateChart from "./Charts/SatisfactionRateChart";
import InterestChart from "./Charts/InterestChart";
import EvaluationListItems from "./Charts/EvaluationListItems";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";

const EvaluationResult = ({ eventId, toggleEvaluation }) => {
  const [isFetching, setIsFetching] = useState(false);
  const [results, setResults] = useState();
  const getResults = async (eventId) => {
    const data = await fetchResults(eventId);

    console.log("Data from results", data);

    const parsedData = data.map(item => JSON.parse(item.answers));

    console.log("Parsed data", parsedData);

    setResults(parsedData);
  }

  useEffect(() => {
    if (!eventId) return;
    if (isFetching) return;

    setIsFetching(true);
    getResults(eventId);
  }, [eventId, getResults, isFetching, setIsFetching]);
  return (
    <div className="table__container">
      <div className="table__title" style={{ display: "flex", alignItems: "center", gap: "0.5rem"}}>
        <span onClick={() => toggleEvaluation()} style={{ cursor: "pointer", fontSize: "0.9rem"}}><FontAwesomeIcon icon={faArrowLeft} /></span>
        <span>Evaluation Results</span>
      </div>

      <div className="evaluation__result--content">
        <div className="evaluation__result--item">
          <div className="result__item--header">Event Rate</div>
          <div className="result__item--content result__item--chart">
            {results && <EventRateChart results={results} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The session delivered the information I expected to receive.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={1} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The subject matter was presented effectively.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={2} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The pace of the event was satisfactory.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={3} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The duration of the event was sufficient for the material covered.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={4} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The resource speakers were knowledgeable.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={5} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">As a result of this event, I gained new knowledge applicable to my professional development.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={6} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">I plan to apply what I learned in this event.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={7} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">Event like this is effective way for me and my colleagues to obtain information and training.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={8} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">The presenters responded to questions.</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={9} />}
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">I would recommend others to join future events by Petrosphere and its partner(s).</div>
          <div className="result__item--content result__item--chart">
            {results && <SatisfactionRateChart results={results} index={10} />}
          </div>
        </div>

        <div className="evaluation__row">
          <div className="evaluation__result--item">
            <div className="result__item--header">What did you like MOST about the event?</div>
            <div className="result__item--content result__item--chart">
              {results && <EvaluationListItems results={results} propNam="like-most" />}
            </div>
          </div>

          <div className="evaluation__result--item">
            <div className="result__item--header">What did you like LEAST about the event?</div>
            <div className="result__item--content result__item--chart">
              {results && <EvaluationListItems results={results} propNam="like-least" />}
            </div>
          </div>
        </div>

        <div className="evaluation__row">
          <div className="evaluation__result--item">
            <div className="result__item--header">Suggest a future topic for event you would like to attend</div>
            <div className="result__item--content result__item--chart">
              {results && <EvaluationListItems results={results} propNam="suggest" />}
            </div>
          </div>

          <div className="evaluation__result--item">
            <div className="result__item--header">Do you have any additional comments about the webinar?</div>
            <div className="result__item--content result__item--chart">
              {results && <EvaluationListItems results={results} propNam="comments" />}
            </div>
          </div>
        </div>

        <div className="evaluation__result--item">
          <div className="result__item--header">Interested in attending future events offered by Petrosphere and its partner(s).</div>
          <div className="result__item--content result__item--chart">
            {results && <InterestChart results={results} />}
          </div>
        </div>
      </div>
    </div>
  );
};

export default EvaluationResult;
